import React from "react";
import "./aboutUs.css";
import Carousel from "react-bootstrap/Carousel";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faFlag,
  faEye,
  faStar,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";

import aboutUsimagePt1 from "../../imagens/aboutUs/aboutUs1.jpeg";
import aboutUsimagePt4 from "../../imagens/aboutUs/aboutUs4.jpeg";
import aboutUsimagePt5 from "../../imagens/aboutUs/aboutUs5.jpeg";
import aboutUsimagePt6 from "../../imagens/aboutUs/aboutUs6.jpeg";
import aboutUsimagePt7 from "../../imagens/aboutUs/aboutUs7.jpeg";
import aboutUsimagePt9 from "../../imagens/aboutUs/aboutUs9.jpeg";
import aboutUsimagePt10 from "../../imagens/aboutUs/aboutUs10.jpeg";

const CAROUSEL_INTERVAL = 3000;

const carouselImagesByLang = {
  pt: [
    aboutUsimagePt10,
    aboutUsimagePt9,
    aboutUsimagePt1,
    aboutUsimagePt4,
    aboutUsimagePt5,
    aboutUsimagePt6,
    aboutUsimagePt7,
  ],
};

function AboutUs() {
  const { t, i18n } = useTranslation();
  const carouselImages =
    carouselImagesByLang[i18n.language] || carouselImagesByLang.pt;

  const itemMissao = t("aboutUs.institucionais.missao", { returnObjects: true });
  const itemVisao = t("aboutUs.institucionais.visao", { returnObjects: true });
  const itemValores = t("aboutUs.institucionais.valores", { returnObjects: true });

  return (
    <div className="container-fluid p-0 m-0" style={{ overflowX: "hidden" }} id="aboutUs">

      {/* TOPO */}
      <div className="row align-items-center justify-content-center m-0 gy-4">
        <div className="col-lg-5 col-md-6 col-12 TextAboutUsContainer px-4">
          <h1 className="text-center textAboutUs mt-4 mb-3">
            {t("aboutUs.title")}
          </h1>
          <p className="TextAboutUsParagraph m-0">
            {t("aboutUs.description")}
          </p>
          <div className="text-center mt-3 mb-4">
            <Link to="/Capabilities/Production">
              <button type="button" className="align-items-center buttonCapabilities">
                {t("aboutUs.button")}
                <FontAwesomeIcon className="ms-2" icon={faArrowRight} />
              </button>
            </Link>
          </div>
        </div>

        <div className="col-lg-7 col-md-6 col-12 px-0">
          <Carousel className="mb-3 shadow-sm mx-0 mx-md-2">
            {carouselImages.map((imgSrc, index) => (
              <Carousel.Item key={index} interval={CAROUSEL_INTERVAL}>
                <img
                  className="d-block custom-carousel-height"
                  src={imgSrc}
                  alt={`MGSUL - ${t("aboutUs.title")} ${index + 1}`}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </div>

      {/* CARDS */}
      <div className="container pb-5 pt-4">
        <div className="custom-grid-container">

          {/* MISSÃO */}
          <div className="custom-card-wrapper split-card">
            <div className="card  shadow-sm text-center">
              <div className="card-body d-flex flex-column align-items-center">
                <div className="icon-circle mb-3 d-flex align-items-center justify-content-center">
                  <FontAwesomeIcon icon={faFlag} size="lg" />
                </div>
                <h5 className="card-title fw-bold">{itemMissao.title}</h5>
                <p className="card-text flex-grow-1">{itemMissao.description}</p>
              </div>
            </div>
          </div>

          {/* VISÃO */}
          <div className="custom-card-wrapper split-card">
            <div className="card valores shadow-sm text-center">
              <div className="card-body d-flex flex-column align-items-center">
                <div className="icon-circle mb-3 d-flex align-items-center justify-content-center">
                  <FontAwesomeIcon icon={faEye} size="lg" />
                </div>
                <h5 className="card-title fw-bold">{itemVisao.title}</h5>
                <p className="card-text flex-grow-1">{itemVisao.description}</p>
              </div>
            </div>
          </div>

          {/* VALORES */}
          <div className="custom-card-wrapper full-card">
            <div className="card valores shadow-sm text-center">
              <div className="card-body d-flex flex-column align-items-center">
                <div className="icon-circle mb-3 d-flex align-items-center justify-content-center">
                  <FontAwesomeIcon icon={faStar} size="lg" />
                </div>
                <h5 className="card-title fw-bold">{itemValores.title}</h5>

                <ul className="list-unstyled text-start valores-list">
                  {itemValores.items.map((valor, i) => (
                    <li key={i} className="d-flex align-items-start mb-2">
                      <FontAwesomeIcon icon={faCheck} className="me-2 check-icon" />
                      <span>
                        <strong>{valor.title}</strong> {valor.text}
                      </span>
                    </li>
                  ))}
                </ul>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default AboutUs;
